import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getVisitedPages, getWhoVisited } from '../../services/adminInsights.service';

// Jenn, 2026-10-08, after the quarterly check-in glitch: "The system needs to
// keep track of page visits. So we can know who to contact when glitches like
// this happen." Pick a page and dates → everyone who opened it, and when.
const dayStr = (d) => d.toLocaleDateString('en-CA', { timeZone: 'America/Halifax' });
const when = (iso) => new Date(iso).toLocaleString(undefined, { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });

export default function PageVisits() {
  const [from, setFrom] = useState(dayStr(new Date(Date.now() - 6 * 864e5)));
  const [to, setTo] = useState(dayStr(new Date()));
  const [pages, setPages] = useState(null);
  const [page, setPage] = useState('');
  const [people, setPeople] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    setError('');
    getVisitedPages(from, to).then(r => setPages(r.pages)).catch(() => setError('Could not load page visits.'));
  }, [from, to]);

  useEffect(() => {
    if (!page) { setPeople(null); return; }
    getWhoVisited(page, from, to).then(r => setPeople(r.people)).catch(() => setError('Could not load who visited.'));
  }, [page, from, to]);

  return (
    <div className="bg-white rounded-2xl shadow-sm p-5 mb-6">
      <h2 className="text-base font-bold text-reset-brown">Who visited a page</h2>
      <p className="text-xs text-gray-500 mt-0.5 mb-4">Every My Hub page members open is counted (from Oct 8, 2026). Pick a page to see who opened it, so you know who to contact if something went wrong there.</p>

      <div className="flex items-end gap-3 flex-wrap text-sm">
        <label className="flex flex-col text-xs text-gray-500 gap-1">Page
          <select value={page} onChange={e => setPage(e.target.value)} className="border border-gray-200 rounded-lg px-2 py-1.5 text-sm text-reset-brown bg-white min-w-[14rem]">
            <option value="">{pages ? (pages.length ? 'Choose a page…' : 'No visits in these dates') : 'Loading…'}</option>
            {(pages || []).map(p => <option key={p.page} value={p.page}>{p.page} · {p.people} {p.people === 1 ? 'person' : 'people'}</option>)}
          </select>
        </label>
        <label className="flex flex-col text-xs text-gray-500 gap-1">From
          <input type="date" value={from} max={to} onChange={e => setFrom(e.target.value)} className="border border-gray-200 rounded-lg px-2 py-1.5 text-sm text-reset-brown" />
        </label>
        <label className="flex flex-col text-xs text-gray-500 gap-1">To
          <input type="date" value={to} min={from} onChange={e => setTo(e.target.value)} className="border border-gray-200 rounded-lg px-2 py-1.5 text-sm text-reset-brown" />
        </label>
      </div>

      {error && <p className="text-sm text-gray-600 mt-3">{error}</p>}

      {people && (
        <div className="mt-4 divide-y divide-gray-50 border border-gray-100 rounded-xl">
          {people.length === 0 && <p className="text-sm text-gray-400 px-4 py-3">Nobody opened this page in these dates.</p>}
          {people.map(p => (
            <div key={p.memberId} className="flex items-center justify-between gap-3 px-4 py-2.5 flex-wrap">
              <div className="min-w-0">
                <Link to={`/admin/members/${p.memberId}`} className="text-sm font-semibold text-reset-brown hover:underline">{p.name}</Link>
                {p.isStaff && <span className="ml-2 text-[10px] px-2 py-0.5 rounded-full bg-reset-sage/10 text-reset-sage">Team365</span>}
                {p.isDemo && <span className="ml-2 text-[10px] px-2 py-0.5 rounded-full bg-gray-100 text-gray-500">practice</span>}
                {p.email && <p className="text-xs text-gray-400">{p.email}</p>}
              </div>
              <p className="text-xs text-gray-500">
                {p.visits} {p.visits === 1 ? 'visit' : 'visits'} · {p.visits === 1 ? when(p.lastAt) : `first ${when(p.firstAt)}, last ${when(p.lastAt)}`}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
